<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-29 11:28:50
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-10 20:00:37
 * @FilePath: /chaoyongtuan/src/views/secondColonelManage/myActivities/list/components/tableCell/activityStatusCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="hit fz-12" :class="[, 'start', 'success', 'end'][$isDy(column.platformId) ? row.activity_status : row.activity_status - 1]">
		{{ row.activity_status_desc }}</div
	>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	components: {},
	data() {
		return {};
	},
};
</script>
<style lang="less">
.hit {
	display: flex;
	align-items: center;

	&::before {
		content: '';
		width: 4px;
		height: 4px;
		border-radius: 50%;
		margin-right: 4px;
	}

	&.start::before {
		background-color: #999999;
	}

	&.success::before {
		background-color: #0fb820;
	}

	&.end::before {
		background-color: red;
	}
}

</style>
